module.exports = __webpack_public_path__ + "nf.24fa151c4df0884d3a6c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/nf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/nf.svg
// module chunks = styles